import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, Search } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function SmartSearchBar({ big = false }) {
  const { t } = useI18n();
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/explore?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <form onSubmit={submit} className="w-full" data-testid="smart-search-form">
      <div className={`tracing-beam rounded-2xl flex items-center gap-3 ${big ? "p-2 pl-5" : "p-1.5 pl-4"} shadow-xl shadow-sky-500/10`}>
        <Sparkles className={`text-[#0EA5E9] shrink-0 ${big ? "h-6 w-6" : "h-5 w-5"}`} />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={t("home.searchPlaceholder")}
          data-testid="smart-search-input"
          className={`flex-1 bg-transparent outline-none text-[#0F172A] placeholder:text-[#94A3B8] ${big ? "text-base md:text-lg py-3" : "py-2 text-sm"}`}
        />
        <button
          type="submit"
          data-testid="smart-search-submit"
          className={`shrink-0 bg-[#0F172A] hover:bg-[#0EA5E9] text-white font-semibold rounded-xl transition-colors flex items-center gap-2 ${big ? "px-6 py-3" : "px-4 py-2 text-sm"}`}
        >
          <Search className="h-4 w-4" />
          <span className="hidden sm:inline">{t("home.searchBtn")}</span>
        </button>
      </div>
    </form>
  );
}
